import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core';
import { ButtonComponent, Carousel2ItemComponent, Carousel2Component, RecipeImpressionArgs, TickerComponent } from '@woolworthsnz/styleguide';
import { createRecipeImpressionArgs } from '../../helpers';
import { getRecipePath } from '../../helpers/recipe-path';
import { MealPlan, RecipeStampLocal, Stamp, StampType } from '../../models';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { StampBasicComponent } from '../stamp-basic/stamp-basic.component';
import { NgFor } from '@angular/common';

dayjs.extend(advancedFormat);

@Component({
	selector: 'recipe-past-meal-plans',
	templateUrl: './past-meal-plans.component.html',
	styleUrls: ['./past-meal-plans.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [TickerComponent, Carousel2Component, NgFor, Carousel2ItemComponent, StampBasicComponent, ButtonComponent]
})
export class PastMealPlansComponent implements OnInit, OnChanges {
	@Input() public pastMealPlans: MealPlan[];
	@Input() public dates: string[];
	@Input() public columns: number;
	@Output() public saveOrUnsaveRecipe = new EventEmitter<{ id: number; isSaved: boolean }>();

	public stampType = StampType.meal;
	public carouselName = 'past-meal-plans';
	public activeMealPlan: MealPlan;

	public ngOnInit(): void {
		if (!this.pastMealPlans?.length) {
			return;
		}
		this.setActiveMealPlan(this.pastMealPlans.length - 1);
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (!('pastMealPlans' in changes)) {
			return;
		}
		this.handleMealPlansChanges(changes);
	}

	public handleNavClick({ index }: { index: number }): void {
		this.setActiveMealPlan(index);
	}

	public addToNewMealPlan(): void {
		// Todo
	}

	public getRecipePath(stamp: Stamp): string {
		return getRecipePath(stamp.recipe.mealTimes, stamp.recipe.title, stamp.recipe.id);
	}

	public getRecipeImpressionArgs(recipe: RecipeStampLocal, index: number): RecipeImpressionArgs {
		return createRecipeImpressionArgs(recipe, index + 1, this.carouselName);
	}

	private setActiveMealPlan(index: number): void {
		if (!this.pastMealPlans?.length || index > this.pastMealPlans.length) {
			return;
		}
		this.activeMealPlan = this.pastMealPlans[index];
	}

	private handleMealPlansChanges(changes: SimpleChanges): void {
		const hasNumberOfPlansChanged =
			changes.pastMealPlans.currentValue.length !== changes.pastMealPlans.previousValue.length;
		const startIndex = this.pastMealPlans.length - 1;
		const currentlyActiveMealPlanIndex = this.pastMealPlans.findIndex(
			(mealPlan) => mealPlan.orderId === this.activeMealPlan.orderId
		);

		this.setActiveMealPlan(hasNumberOfPlansChanged ? startIndex : currentlyActiveMealPlanIndex);
	}
}
